<!-- components/CodeSection.vue -->
<template>
  <div>
    <div
      v-for="(item, index) in content"
      :key="index"
      class="mb-6"
    >
      <h4 class="text-md font-semibold mb-2">
        {{ item.title }}
      </h4>
      <p
        v-if="item.text"
        class="text-gray-700 mb-3"
      >
        {{ item.text }}
      </p>
        
      <div class="relative bg-gray-800 rounded-md overflow-hidden">
        <!-- Code header with language label and copy button -->
        <div class="bg-[#2d3748] px-4 py-2 flex justify-between items-center">
          <span class="text-xs font-mono text-gray-300 uppercase">{{ item.language }}</span>
          <button 
            class="text-xs bg-[#1A56DB] hover:bg-[#3c3ce6] text-white py-1 px-2 rounded transition-colors duration-200 flex items-center" 
            @click="copyToClipboard(item.code)"
          >
            <i class="fas fa-copy mr-1" /> 
            <span>{{ copied[index] ? 'Copied!' : 'Copy' }}</span>
          </button>
        </div>
          
        <!-- Code content with syntax highlighting -->
        <pre class="p-4 text-sm overflow-x-auto"><code>{{ item.code }}</code></pre>
      </div>
    </div>
  </div>
</template>
  
  <script>
  export default {
    name: 'CodeSection',
    props: {
      content: {
        type: Array,
        required: true
      }
    },
    data() {
      return {
        copied: {}
      };
    },
    methods: {
      copyToClipboard(text) {
        navigator.clipboard.writeText(text).then(() => {
          // Find index of the copied item
          const index = this.content.findIndex(item => item.code === text);
          
          // Set the copied state for this specific code block
          this.$set(this.copied, index, true);
          
          // Reset after 2 seconds
          setTimeout(() => {
            this.$set(this.copied, index, false);
          }, 2000);
        }).catch(err => {
          console.error('Failed to copy text: ', err);
        });
      }
    }
  };
  </script>
  
  <style scoped>
  pre {
    margin: 0;
    background-color: #1e293b;
    color: #e2e8f0;
    font-family: 'Inter', sans-serif;
    scrollbar-width: thin;
    scrollbar-color: #4b5563 #1f2937;
  }
  
  pre::-webkit-scrollbar {
    height: 8px;
  }
  
  pre::-webkit-scrollbar-track {
    background: #1f2937;
    border-radius: 0 0 4px 4px;
  }
  
  pre::-webkit-scrollbar-thumb {
    background-color: #1A56DB;
    border-radius: 4px;
  }
  </style>